<template>
    <section class="general-header">
        <div class="container">

            <div class="row">

                <div class="col-lg-8 ml-auto mr-auto">
                    <h1 class="general-header__header">{{content.header}}</h1>
                    <p v-if="content.subheader" class="mb-4">{{content.subheader}}</p>
                    <div v-if="content.buttonText">

                        <div v-if="content.link && !content.to">

                            <a v-if="content.iconPosition === 'left'" :href="content.link" class="btn btn-orange">
                                <font-awesome-icon :icon="['fal', content.buttonIcon]" class="fa fa-fw" />
                                {{content.buttonText}}
                            </a>

                            <a v-if="content.iconPosition === 'right'" :href="content.link" class="btn btn-orange">
                                {{content.buttonText}}
                                <font-awesome-icon :icon="['fal', content.buttonIcon]" />
                            </a>

                            <a v-if="!content.iconPosition" :href="content.link" class="btn btn-orange">
                                {{content.buttonText}}
                            </a>

                        </div>

                        <div v-if="!content.link && content.to">

                            <router-link v-if="content.iconPosition === 'left'" :to="{name: content.to}" class="btn btn-orange">
                                <font-awesome-icon :icon="['fal', content.buttonIcon]" class="fa fa-fw" />
                                {{content.buttonText}}
                            </router-link>

                            <router-link v-if="content.iconPosition === 'right'" :to="{name: content.to}" class="btn btn-orange">
                                {{content.buttonText}}
                                <font-awesome-icon :icon="['fal', content.buttonIcon]" />
                            </router-link>

                            <router-link v-if="!content.iconPosition" :to="{name: content.to}" class="btn btn-orange">
                                {{content.buttonText}}
                            </router-link>

                        </div>

                    </div>
                </div>

            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: 'general-header',
    props: ['content'],
    data: function () {
        return {}
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .general-header {
        padding: 55px 0px;
        color: $white;
        background: $green;
        text-align: center;

        &__header {
            color: $white;
            margin-bottom: 25px;
        }
    }
</style>
